export default "__VITE_ASSET__CuEU_x9o__"